export const FETCH_REPORT_BEGIN = "FETCH_REPORT_BEGIN";
export const FETCH_REPORT_SUCCESS = "FETCH_REPORT_SUCCESS";
export const FETCH_REPORT_FAILURE = "FETCH_REPORT_FAILURE";
export const UPDATE_REPORT_BEGIN = "UPDATE_REPORT_BEGIN";
export const UPDATE_REPORT_SUCCESS = "UPDATE_REPORT_SUCCESS";
export const UPDATE_REPORT_FAILURE = "UPDATE_REPORT_FAILURE";
export const CREATE_COMMENT_BEGIN = "CREATE_COMMENT_BEGIN";
export const CREATE_COMMENT_SUCCESS = "CREATE_COMMENT_SUCCESS";
export const CREATE_COMMENT_FAILURE = "CREATE_COMMENT_FAILURE";
export const DELETE_COMMENT_BEGIN = "DELETE_COMMENT_BEGIN";
export const DELETE_COMMENT_SUCCESS = "DELETE_COMMENT_SUCCESS";
export const DELETE_COMMENT_FAILURE = "DELETE_COMMENT_FAILURE";
export const SCROLL_COMPLETE = "SCROLL_COMPLETE";
export const DOWNLOAD_REPORT_BEGIN = "DOWNLOAD_REPORT_BEGIN";
export const DOWNLOAD_REPORT_SUCCESS = "DOWNLOAD_REPORT_SUCCESS";
export const DOWNLOAD_REPORT_FAILURE = "DOWNLOAD_REPORT_FAILURE";
export const REORDER_COMMENTS_BEGIN = "REORDER_COMMENTS_BEGIN";
export const REORDER_COMMENTS_SUCCESS = "REORDER_COMMENTS_SUCCESS";
export const REORDER_COMMENTS_FAILURE = "REORDER_COMMENTS_FAILURE";
export const START_EDIT = "START_EDIT";
export const END_EDIT = "END_EDIT";
